module.exports = __webpack_public_path__ + "img/pro_fourteen_1.4ed72b4f.jpg";